module.exports = __webpack_public_path__ + "static/media/pic11.4a93c0d0.jpg";